import { createSlice } from '@reduxjs/toolkit';
import { ISidebar } from '../../../core/components/sidebars/ISidebar';
import { SidebarReducer } from '../../reducers/SidebarReducer';

const initialState: ISidebar = {
	isOpen: false,
	component: null,
	title: '',
};

export const sidebarSlice = createSlice({
	name: 'sidebar',
	initialState,
	reducers: SidebarReducer,
});

export const { toggleSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
